import { DefaultCrewMember, DefaultEquipmentMember } from '@services/schedules/internal/types';
import { getFullName } from '@utils/textHelpers';

export const getCrewNames = (members: DefaultCrewMember[] = []) =>
  members
    .filter((el) => !el.discardedAt)
    .map((el) => getFullName(el.firstName, el.lastName))
    .filter(Boolean);

export const getEquipmentNames = (members: DefaultEquipmentMember[] = []) =>
  members
    .filter((el) => !el.discardedAt)
    .map((el) => [el.internalId, el.name].filter(Boolean).join(' '))
    .filter(Boolean);
